<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap pl-lg-6>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap pl-2>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-btn @click="filter_data" color="#3480c1" outlined>Xem</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12>            
            <template v-for="(item, i) in items">
                <div v-bind:key="i">
                  <h4>Tháng: {{item.month.replace(/(\d{4})(\d{2})/, "$2-$1")}}</h4>
                  <v-card class="mb-8">
                      <v-data-table hide-default-footer :headers="headers" :items="item.rows" disable-pagination :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                          <template v-slot:item="{ item }">
                              <tr>
                                  <td>{{ getStaffName(item.CustomerServiceID) }}</td>
                                  <td class="text-end">{{ item.NumberOfOrder | currency }}</td>
                                  <td class="text-end">{{ item.TotalAmount | currency('¥', 2) }}</td>
                                  <td class="text-end">{{ item.RevenueCommission | currency('¥', 2) }}</td>
                                  <td class="text-end">{{ item.RevenueCommissionVND | currency }}</td>
                              </tr>
                          </template>
                          <template v-slot:body.append>
                            <tr>
                              <td class="font-weight-bold">TỔNG</td>
                              <td class="text-end font-weight-bold">{{dic_summary[item.month].NumberOfOrder | currency}}</td>
                              <td class="text-end font-weight-bold">{{dic_summary[item.month].TotalAmount | currency('¥', 2)}}</td>
                              <td class="text-end font-weight-bold">{{dic_summary[item.month].RevenueCommission | currency('¥', 2)}}</td>
                              <td class="text-end font-weight-bold">{{dic_summary[item.month].RevenueCommissionVND | currency}}</td>
                            </tr>
                          </template>
                      </v-data-table>
                  </v-card>
                </div>
            </template>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="text-error text-itatic">
        <v-flex lg12 sm12 pb-0 pt-0>
          <v-card-title>(Thống kê tính theo ngày cọc đơn)</v-card-title>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment";
export default {
  data() {
    return {
      headers: [
        {
          text: "Nhân viên CSKH",
          value: "CustomerServiceID",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số đơn hoàn thành",
          value: "NumberOfOrder",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tổng tiền hàng",
          value: "TotalAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Hoa hồng (¥)",
          value: "RevenueCommission",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Hoa hồng (đ)",
          value: "RevenueCommissionVND",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        }
      ],
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "thong-ke-hoa-hong-nhan-vien",
      dateRange: {
        startDate: moment
          .utc(Date.now())
          .startOf("month")
          .toISOString()
          .substr(0, 10),
        endDate: moment
          .utc(Date.now())
          .endOf("month")
          .toISOString()
          .substr(0, 10)
      },
      menuStart: false,
      menuEnd: false,
      order_type_list: configs.ORDER_TYPE_LIST
    };
  },
  watch: {
    pagination: {
        handler: function (val, oldVal) {
            this.filter_data();
        },
        deep: true
    },
  },
  computed: {
    ...mapState({
      items: state => state.analytic.commission_analytic.data,
      loading: state => state.analytic.loading,
      staffs: state =>
          _.filter(state.commons.all_users, function(o) {
          return ((o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase) || ((o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
      }),
    }),
    computedStartDateFormatted() {
      return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
    },
    computedEndDateFormatted() {
      return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    dic_summary() {
      let dic = {};
      for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];
          dic[item.month] = {
              'NumberOfOrder': _.sumBy(item.rows, 'NumberOfOrder'),
              'TotalAmount': _.sumBy(item.rows, 'TotalAmount'),
              'RevenueCommission': _.sumBy(item.rows, 'RevenueCommission'),
              'RevenueCommissionVND': _.sumBy(item.rows, 'RevenueCommissionVND')
          }
      }
      return dic;
    }
  },
  methods: {
    filter_data: _.debounce(function () {
      var param = {
        pagination: this.pagination,
        startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
        endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
      };
      this.$store.dispatch("analytic/getCommissionAnalytic", param);
    }, 300, {
        'leading': true,
        'trailing': false
    }),
    getStaffName(staffId) {
      const staff = _.find(this.staffs, {
          ID: staffId
      });
      return staff ? staff.FullName : "";
    }
  },
  mounted() {
    this.filter_data();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>